<template>
    <div class="content_nav">
        <div class="echarts_nav" id="echarts_1"></div>
        <div class="center_nav">
          <div class="center_echarts" id="echarts_2"></div>
          <div class="center_echarts" id="echarts_3"></div>
          <div class="center_echarts" id="echarts_4"></div>
        </div>
        <div class="echarts_nav" id="echarts_5"></div>
    </div>
</template>

<style lang="scss" scoped>
.content_nav{
    width: 100%;
    height: 100%;
    // background-color: #ededed;
}
.echarts_nav{
  width: 100%;
  height: 450px;
  margin-bottom: 30px;
  background-color: #fff;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}
.center_nav{
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  .center_echarts{
    width: 32%;
    height: 300px;
    background-color: #fff;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
}
</style>

<script>
export default {
  name:'Main',
  data() {
    return {}
  },
  mounted(){
    this.setEcharts();
  },
  methods:{
    setEcharts(){
        const myecharts = this.$echarts.init(document.getElementById('echarts_1'));
        const myecharts2 = this.$echarts.init(document.getElementById('echarts_2'));
        const myecharts3 = this.$echarts.init(document.getElementById('echarts_3'));
        const myecharts4 = this.$echarts.init(document.getElementById('echarts_4'));
        const myecharts5 = this.$echarts.init(document.getElementById('echarts_5'));
        var option = {
		tooltip: {
		  trigger: 'axis',
		  axisPointer: {
			type: 'cross',
			crossStyle: {
			  color: '#999'
			}
		  }
		},
		toolbox: {
		  feature: {
			dataView: { show: true, readOnly: false },
			magicType: { show: true, type: ['line', 'bar'] },
			restore: { show: true },
			saveAsImage: { show: true }
		  }
		},
		legend: {
		  data: ['充电电费', '充电服务费', '充电车次','充电量']
		},
		xAxis: [
		  {
			type: 'category',
			data: ['10-01','10-02','10-03','10-04','10-05','10-06','10-07','10-08','10-09','10-10'],
			axisPointer: {
			  type: 'shadow'
			}
		  }
		],
		yAxis: [
		  {
			type: 'value',
			name: '充电电费',
			// min: 0,
			// max: 250,
			// interval: 50,
			axisLabel: {
			  formatter: '{value} 元'
			}
		  },
		  {
			type: 'value',
			name: '充电量',
			// min: 0,
			// max: 25,
			// interval: 5,
			axisLabel: {
			  formatter: '{value} kwh'
			}
		  }
		],
		series: [
		  {
			name: '充电电费',
			type: 'bar',
			tooltip: {
			  valueFormatter: function (value) {
				return value + ' 元';
			  }
			},
			data: [3145.66,3245.32,3045.69,3295,3345,3645,4145,5245,6045,6345]
		  },
		  {
			name: '充电服务费',
			type: 'bar',
			tooltip: {
			  valueFormatter: function (value) {
				return value + ' 元';
			  }
			},
			data: [1314.66,1345.32,1345.69,1395,1545,1645,1745,1845,1645,1945]
		  },
		  {
			name: '充电车次',
			type: 'bar',
			tooltip: {
			  valueFormatter: function (value) {
				return value + ' 次';
			  }
			},
			data: [314,245,345,395,345,445,415,545,645,695]
		  },
		  {
			name: '充电量',
			type: 'line',
			smooth: 0.5, // 设置曲线弧度为 0.5
			yAxisIndex: 1,
			tooltip: {
			  valueFormatter: function (value) {
				return value + ' kwh';
			  }
			},
			data: [3145.66,3245.32,3045.69,3295,3345,3645,4145,5245,6045,6345]
		  }
		]
	  };

var option2 = {
  title: [
    {
      text: ''
    }
  ],
  polar: {
    radius: [30, '80%']
  },
  angleAxis: {
    max: 4,
    startAngle: 75
  },
  radiusAxis: {
    type: 'category',
    data: ['a', 'b', 'c', 'd']
  },
  tooltip: {},
  series: {
    type: 'bar',
    data: [2, 1.2, 2.4, 3.6],
    coordinateSystem: 'polar',
    label: {
      show: true,
      position: 'middle',
      formatter: '{b}: {c}'
    }
  }
};
var option3 = {
  title: {
    text: '排行榜'
  },
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  legend: {},
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'value',
    boundaryGap: [0, 0.01]
  },
  yAxis: {
    type: 'category',
    data: ['Brazil', 'Indonesia', 'USA', 'India', 'China', 'World']
  },
  series: [
    {
      name: '2011',
      type: 'bar',
      data: [18203, 23489, 29034, 104970, 131744, 630230]
    },
    {
      name: '2012',
      type: 'bar',
      data: [19325, 23438, 31000, 121594, 134141, 681807]
    }
  ]
};

var option4 = {
  title: {
    text: 'Rainfall vs Evaporation',
    subtext: 'Fake Data'
  },
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: ['Rainfall', 'Evaporation']
  },
  toolbox: {
    show: true,
    feature: {
      dataView: { show: true, readOnly: false },
      magicType: { show: true, type: ['line', 'bar'] },
      restore: { show: true },
      saveAsImage: { show: true }
    }
  },
  calculable: true,
  xAxis: [
    {
      type: 'category',
      // prettier-ignore
      data: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  ],
  yAxis: [
    {
      type: 'value'
    }
  ],
  series: [
    {
      name: 'Rainfall',
      type: 'bar',
      data: [
        2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3
      ],
      markPoint: {
        data: [
          { type: 'max', name: 'Max' },
          { type: 'min', name: 'Min' }
        ]
      },
      markLine: {
        data: [{ type: 'average', name: 'Avg' }]
      }
    },
    {
      name: 'Evaporation',
      type: 'bar',
      data: [
        2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3
      ],
      markPoint: {
        data: [
          { name: 'Max', value: 182.2, xAxis: 7, yAxis: 183 },
          { name: 'Min', value: 2.3, xAxis: 11, yAxis: 3 }
        ]
      },
      markLine: {
        data: [{ type: 'average', name: 'Avg' }]
      }
    }
  ]
};

var option5 = {
  angleAxis: {
    type: 'category',
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  },
  radiusAxis: {},
  polar: {},
  series: [
    {
      type: 'bar',
      data: [1, 2, 3, 4, 3, 5, 1],
      coordinateSystem: 'polar',
      name: 'A',
      stack: 'a',
      emphasis: {
        focus: 'series'
      }
    },
    {
      type: 'bar',
      data: [2, 4, 6, 1, 3, 2, 1],
      coordinateSystem: 'polar',
      name: 'B',
      stack: 'a',
      emphasis: {
        focus: 'series'
      }
    },
    {
      type: 'bar',
      data: [1, 2, 3, 4, 1, 2, 5],
      coordinateSystem: 'polar',
      name: 'C',
      stack: 'a',
      emphasis: {
        focus: 'series'
      }
    }
  ],
  legend: {
    show: true,
    data: ['A', 'B', 'C']
  }
};
myecharts.setOption(option,true);
myecharts2.setOption(option2,true);
myecharts3.setOption(option3,true);
myecharts4.setOption(option5,true);
myecharts5.setOption(option4,true);
    }
  }
}
</script>